import { render, staticRenderFns } from "./payError.vue?vue&type=template&id=04507f5f&scoped=true&"
import script from "./payError.vue?vue&type=script&lang=js&"
export * from "./payError.vue?vue&type=script&lang=js&"
import style0 from "./payError.vue?vue&type=style&index=0&id=04507f5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04507f5f",
  null
  
)

export default component.exports